import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { notification, Spin } from "antd";

const CheckoutStatus = () => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const cartId = params.get("cartId");

        if (cartId) {
            notification.success({
                message: "Payment Successful!",
                description: "Thank you for your purchase. Your order has been confirmed.",
                duration: 3,
            });
        } else {
            notification.error({
                message: "Payment Failed!",
                description: "Your payment was not processed. Please try again.",
                duration: 3,
            });
        }

        // ⏳ Redirect user after notification
        setTimeout(() => {
            navigate("/"); // Change to your home/dashboard route
        }, 3000);
    }, [location, navigate]);

    return (
        <div style={{height: '100vh', width: '100vw', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            <Spin size="large" />
            <p>Redirecting...</p>
        </div>
    );
};

export default CheckoutStatus;
